// Photo uploads (damage reports, tool images) via Cloud Storage for Firebase.
import { storage } from "./firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const MIME_TYPES = {
  jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", gif: "image/gif", webp: "image/webp",
};
const MAX_BYTES = 5 * 1024 * 1024;

// Uploads a File and returns its public download URL (stored directly as
// image_url / photo_urls entries — no separate backend proxy needed).
export async function uploadImage(file, uid) {
  const ext = (file.name || "bin").split(".").pop().toLowerCase();
  if (!MIME_TYPES[ext]) throw new Error(`Unsupported file type .${ext}`);
  if (file.size > MAX_BYTES) throw new Error("File exceeds 5MB limit");
  const path = `uploads/${uid}/${crypto.randomUUID()}.${ext}`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, file, { contentType: file.type || MIME_TYPES[ext] });
  return getDownloadURL(fileRef);
}
